import "./service-card.scss";

import { Link } from "gatsby";
import React from "react";
import { findRel } from "../../../shared/utils/stringUtilities";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";

const ServiceCard = (props: ServiceCardInterface) => {
  const { text, href, icon, alt } = props;
  const isHttp = (url?: string) => {
    return url?.startsWith("http");
  };

  return (
    <div className={"a-service-card"}>
      <div className="a-service-card__icon-container">
        <img
          src={icon}
          alt={alt}
          className={`a-service-card__icon-container icon`}
        />
      </div>
      <Link
        to={`${href}`}
        rel={findRel(href)}
        target={isHttp(href) ? "_blank" : "_self"}
        className={`a-service-card__button gtmRedDeAmorConoceServiciosRedAmor${normalizeTwoWords(
          text
        )}`}
      >
        <h3>{text}</h3>
      </Link>
    </div>
  );
};

interface ServiceCardInterface {
  text: string | null | undefined;
  icon: string;
  href?: string;
  gtmMark?: string;
  target?: string;
  alt: string;
}

export default ServiceCard;
